@if (isOpen) {
  <div class="image-viewer" (click)="close()">
    <fa-icon (click)="close()" icon="times" class="circle-icon-btn close-btn t-30 force-white"></fa-icon>
    @if (images.length > 1) {
      <fa-icon icon="chevron-left" class="circle-icon-btn nav-btn nav-btn-prev t-30 force-white" (click)="prev($event)"></fa-icon>
    }
    @if (srcFailed) {
      <div class="unviewable-photo force-white" (click)="$event.stopPropagation()">
        <fa-icon icon="file-image" class="t-30 m-b-10"></fa-icon>
        <div class="t-16 m-b-5">{{ srcFileName }}</div>
        <div class="t-14 m-b-15">This browser can't display this image format.</div>
        <a [href]="src" target="_blank" rel="noopener" class="force-white">Download</a>
      </div>
    } @else {
      <img [src]="src" (error)="markFailed()" />
    }
    @if (images.length > 1) {
      <fa-icon icon="chevron-right" class="circle-icon-btn nav-btn nav-btn-next t-30 force-white" (click)="next($event)"></fa-icon>
    }
  </div>
}
